import { LoaderCircleIcon } from 'lucide-react';

/** Kleine draaiende cirkel in knoppen tijdens versturen. */
export function Spinner({
  className = 'h-4 w-4'
}: {
  className?: string;
}) {
  return <LoaderCircleIcon aria-hidden="true" className={`animate-spin motion-reduce:animate-none ${className}`} strokeWidth={1.5} data-id="element-8854" data-mp="35j8gj6j8ec3u" />;
}